import {
  SHOW_CREATE_AUDIENCE_MODAL,
  SHOW_EDIT_AUDIENCE_MODAL,
  HIDE_CREATE_AUDIENCE_MODAL,
  CREATE_AUDIENCE_REQUEST,
  CREATE_AUDIENCE_FAILURE,
  CREATE_AUDIENCE_SUCCESS,
  SHOW_COMPARE_AUDIENCE_MODAL,
} from '../../constants/action-types';

const getInitialState = () => {
  return {
    queryBuilderProps: {},
    isVisible: false,
    isLoading: false,
  };
};

const initialState = getInitialState();

const createAudienceModal = (state = initialState, action) => {
  const types = {
    [SHOW_EDIT_AUDIENCE_MODAL]: () => ({
      queryBuilderProps: {
        ...state.queryBuilderProps,
        ...action.queryBuilderProps,
      },
      isVisible: true,
    }),
    [SHOW_CREATE_AUDIENCE_MODAL]: () => ({
      ...state,
      isVisible: true,
    }),
    [SHOW_COMPARE_AUDIENCE_MODAL]: () => ({
      ...state,
      isVisible: true,
    }),
    [HIDE_CREATE_AUDIENCE_MODAL]: () => initialState,
    [CREATE_AUDIENCE_REQUEST]: () => ({
      ...state,
      isLoading: true,
      error: false,
    }),
    [CREATE_AUDIENCE_SUCCESS]: () => ({
      ...initialState,
      isLoading: false,
    }),
    [CREATE_AUDIENCE_FAILURE]: () => ({
      ...state,
      isLoading: false,
    }),
  };

  if (!types[action.type]) {
    return state;
  }

  return types[action.type]();
};

export default createAudienceModal;
